import { render, staticRenderFns } from "./exhibitor-row.vue?vue&type=template&id=0197f6ef&scoped=true"
import script from "./exhibitor-row.vue?vue&type=script&lang=js"
export * from "./exhibitor-row.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-row.vue?vue&type=style&index=0&id=0197f6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197f6ef",
  null
  
)

export default component.exports